import React from "react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./App.css";
import App from "./App.jsx";
import { ThemeProvider } from "next-themes";
import { TooltipProvider } from "./components/ui/tooltip.jsx";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <TooltipProvider>
        <App />
        </TooltipProvider>
    </ThemeProvider>
  </StrictMode>
);
